export default __webpack_public_path__ + "static/media/beginChat.21af079b.svg";